import React, { useEffect } from "react";
import "./index.css";
import { useState } from "react";
import { changeIndexToNepali } from "../../utils";
import MainLoader from "../../components/MainLoader/index";
import ReactExport from "react-export-excel";
import { BounceLoader } from "react-spinners";
import NonReportTable from "../CustomTable/reporttablenon";
import { Button } from "react-bootstrap/lib/InputGroup";
import Api from "../../services/api";
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
const NonMinistryAccordion = (props) => {
  const [id, setId] = useState(0);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [downloadcontent, setDownloadContent] = useState();
  const downloadHandler = async () => {
    if (props.ministryLevel) {
      await Api.downloadministrydownload(
        (localStorage.getItem("user") &&
          JSON.parse(localStorage.getItem("user")).user.fiscal_year_id) ||
          localStorage.getItem("fiscalYear"),
        sessionStorage.getItem("provinceId"),
        sessionStorage.getItem("m_id")
      ).then((res) => {
        let data = res.response.data;
        const questionsArray = [];
        questionsArray.push({
          name: "कुल",
          obtained_marks: data.total_marks,
        });
        for (const key in data) {
          if (data[key].category) {
            questionsArray.push({
              name: data[key].category,
              obtained_marks: data[key].total_obtained_marks,
            });
          }
          if (data[key].questions && Array.isArray(data[key].questions)) {
            questionsArray.push(...data[key].questions);
          }
        }
        setDownloadContent(questionsArray);
      });
    } else {
      await Api.downloadreportyek(
        (localStorage.getItem("user") &&
          JSON.parse(localStorage.getItem("user")).user.fiscal_year_id) ||
          localStorage.getItem("fiscalYear"),
        sessionStorage.getItem("provinceId")
      ).then((res) => {
        let data = res.response.data;
        const questionsArray = [];

        questionsArray.push({
          name: "कुल",
          obtained_marks: data.total_marks,
        });
        for (const key in data) {
          if (data[key].category) {
            questionsArray.push({
              name: data[key].category,
              obtained_marks: data[key].total_obtained_marks,
            });
            if (data[key].questions && Array.isArray(data[key].questions)) {
              console.log(data[key].questions);
              questionsArray.push(...data[key].questions);
            }
          }
        }
        setDownloadContent(questionsArray);
      });
    }
  };
  useEffect(() => {
    downloadHandler();
  }, []);

  useEffect(() => {
    if (props.categories && props.categories.length > 0) {
      const initialId = props.ministryLevel
        ? props.categories[0].category_id
        : props.categories[0].id;
      setId(initialId);
      datafetch(initialId);
    }
  }, [props.categories]);

  const datafetch = async (payload) => {
    if (payload !== id) {
      setId(payload);
      setLoading(true);
      if (props.ministryLevel) {
        await Api.getMinistryReport(
          localStorage.getItem("fiscalYear"),
          sessionStorage.getItem("provinceId"),
          props.ministry_id,
          payload
        )
          .then((res) => {
            console.log(res);
            if (res.code === 200) {
              setData(res.response.questions);
              setLoading(false);
            }
            setLoading(false);
          })
          .catch((err) => {
            console.log(err);
            setLoading(false);
          });
      } else {
        if (!props.url.includes("provincalEvaluation")) {
          await Api.getNonMinistryReport(
            localStorage.getItem("user")
              ? JSON.parse(localStorage.getItem("user")).user.fiscal_year_id
              : localStorage.getItem("fiscalYear"),

            sessionStorage.getItem("provinceId"),
            localStorage.getItem("user")
              ? JSON.parse(localStorage.getItem("user")).user.ocmcm_id
              : sessionStorage.getItem("provinceId"),
            payload
          )
            .then((res) => {
              console.log(res);
              if (res.code === 200) {
                setData(res.response.questions);
                setLoading(false);
              }
              setLoading(false);
            })
            .catch((err) => {
              console.log(err);
              setLoading(false);
            });
        } else {
          await Api.getNonMinistryReport(
            (localStorage.getItem("user") &&
              JSON.parse(localStorage.getItem("user")).user.fiscal_year_id) ||
              localStorage.getItem("fiscalYear"),
            sessionStorage.getItem("provinceId"),
            JSON.parse(localStorage.getItem("user")).user.ocmcm_id,
            payload
          )
            .then((res) => {
              console.log(res);
              if (res.code === 200) {
                setData(res.response.questions);
                setLoading(false);
              }
              setLoading(false);
            })
            .catch((err) => {
              console.log(err);
              setLoading(false);
            });
        }
      }
    } else {
      setId(-1);
    }
  };

  return (
    <>
      {props.categories && (
        <>
          <div className="report-header" style={{ alignItems: "center" }}>
            <p className="sub-heading">स्कोर टेबल</p>
            <ExcelFile
              element={
                <Button
                  color="primary"
                  className="btn btn-primary"
                  style={{ marginRight: 10, float: "right" }}
                  onClick={downloadHandler}
                >
                  डाउनलोड
                </Button>
              }
            >
              <ExcelSheet data={downloadcontent} name="Status">
                <ExcelColumn label="क्र.स." value="indicator" />
                <ExcelColumn label="सूचक" value="name" />
                <ExcelColumn label="पूर्णाङ्क" value="marks" />
                <ExcelColumn label="प्राप्ताङ्क" value="obtained_marks" />
                <ExcelColumn label="कैैफियत" value="remarks" />
              </ExcelSheet>
            </ExcelFile>
          </div>

          <div className={"flex_accordion"}>
            {props.categories &&
              props.categories.map((p, index) => (
                <div className={"accordion_p"}>
                  <p
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      datafetch(props.ministryLevel ? p.category_id : p.id)
                    }
                    className={`accordion_title ${id ===
                      (props.ministryLevel ? p.category_id : p.id) &&
                      "accordion_active"}`}
                  >
                    {changeIndexToNepali(index + 1) + ")"} {p.name}
                  </p>
                  {id === (props.ministryLevel ? p.category_id : p.id) && data && (
                    <div>
                      <MainLoader>
                        <div className="">
                          {loading ? (
                            <div className="w-100 d-flex justify-content-center my-5">
                              {" "}
                              <BounceLoader color="#1f8cd5" />
                            </div>
                          ) : (
                            <NonReportTable comments={data} />
                          )}
                        </div>
                      </MainLoader>
                    </div>
                  )}
                </div>
              ))}
          </div>
        </>
      )}
    </>
  );
};
export default NonMinistryAccordion;
